import { LocalStorageKeys } from '@/app'
import { LocalStorage } from '@/utils'
import { TypeGuards } from '@codeleap/types'

const KEYS_TO_REMOVE = new Set<string>([
  LocalStorageKeys.PERSIST_AUTH,
  LocalStorageKeys.IN_REAUTHENTICATION,
  LocalStorageKeys.QUESTIONS_LAST_AUTO_OPENENED,
  LocalStorageKeys.HAS_SKIPPED_EMAIL_VERIFICATION,
  LocalStorageKeys.LESSON_STORE,
  LocalStorageKeys.CONTRIBUTE_ONBOARDING
])

export function clearStorageKeys() {
  const storageKeys = LocalStorage.getAllKeys()

  if (!TypeGuards.isArray(storageKeys)) return

  for (const key of storageKeys) {
    if (key?.includes('learn') || KEYS_TO_REMOVE.has(key)) {
      LocalStorage.removeItem(key)
    }
  }
}
